import { get, writable } from 'svelte/store';
import { navigate } from '../../../app.logic';
import { formatDateOnlyISO } from '../../../utils/date-utils';
import { QualityIncidentService } from '../../../services/quality-incident.service';
import { ReportService } from '../../../services/report-service';
export const loading = writable(false);
export const filter = writable({ criteria: {} });
export const records = writable([]);
export const pagination = writable(null);
export const record = writable(null);
export async function initList() {
    filter.set({ criteria: {}, params: null, sorting: "" });
    pagination.set({ currentPage: 1, totalPages: 0, totalRecords: 0 });
    record.set(null);
    await load();
}
export async function initDetail(oid) {
    record.set(null);
    if (oid == 0) {
        record.set({
            oid: 0,
            documentDate: formatDateOnlyISO(new Date()),
            year: 0,
            yearlyNumber: 0,
            closed: 0,
            //clfProcedureId: 0,
            sender: "",
            description: "",
            causes: "",
            correction: "",
            estimatedCompletionDate: "",
            actualCompletionDate: "",
            outcome: 0
        });
    }
    else {
        let _resp = await QualityIncidentService.fetchQualityIncident(oid);
        record.set(_resp.payload);
    }
}
export async function search() {
    pagination.set({ currentPage: 1, totalPages: 0, totalRecords: 0 });
    await load();
}
export async function load() {
    loading.set(true);
    try {
        let _filter = get(filter);
        let _pag = get(pagination);
        let _resp = await QualityIncidentService.getQualityIncidents(_filter, _pag.currentPage);
        records.set(_resp.payload);
        pagination.set(_resp.pagination);
    }
    finally {
        loading.set(false);
    }
}
export function onCreate() {
    // console.log("onCreate");
    navigate(`/quality-incident/0`);
}
export function onEdit(item) {
    // console.log("onEdit", item);
    navigate(`/quality-incident/${item.oid}`);
}
export async function save() {
    let _record = get(record);
    return await QualityIncidentService.saveQualityIncident(_record);
}
export async function onDelete(item) {
    // console.log("onDelete", item);
    await QualityIncidentService.deleteQualityIncident(item.oid);
    await load();
}
export function onPageChange(pageNumber) {
    // console.log("onPageChange: " + pageNumber);
    pagination.set(Object.assign(Object.assign({}, get(pagination)), { currentPage: pageNumber }));
    load();
}
export async function onPrint() {
    let rec = get(record);
    if (rec == null || rec.oid == 0)
        return;
    await ReportService.exportPdfQualityIncident(rec.oid);
}
